import React, { useContext, useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import Upload_Routes from "../Components/Upload/Upload_Routes";
import { useNavigate } from "react-router-dom";
import TadobaContext from "../Components/Context/TadobaContext";
import { processFolderUpload } from "../utils/uploadUtils";
import { makeRequest } from "../api";
import { Button, Modal } from "antd";

const Upload = () => {
  const navigate = useNavigate();
  const api = useContext(TadobaContext);
  const [drag, setDrag] = useState(false);
  const [defaultYear, setDefaultYear] = useState(api.defaultYear);
  const [unmatchedFolders, setUnmatchedFolders] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedOption, setSelectedOption] = useState(() => {
    const savedOption = localStorage.getItem("selectedOption");
    return savedOption !== null ? parseInt(savedOption, 10) : 2; // Default to 2 if not found
  });
  const radioOptions = [
    // { id: 0, displayName: "Phase 4" },
    { id: 1, displayName: "Weekly" },
    { id: 2, displayName: "Normal" },
    { id: 3, displayName: "Bulk" },
  ];

  const handleOptionChange = (id) => {
    setSelectedOption(id);
    localStorage.setItem("selectedOption", id);
  };

  useEffect(() => {
    var formData = new FormData();
    for (const key of Object.keys(api.file)) {
      formData.append("files", api.file[key]);
    }
  }, [api.file]);

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    directory: true,
    onDragOver: () => {
      setDrag(true);
    },
    onDragLeave: () => {
      setDrag(false);
    },
    onDrop: (acceptedFiles, rejectedFiles) => {
      const validFiles = acceptedFiles.filter(
        (file) =>
          file.type === "image/png" ||
          file.type === "image/jpg" ||
          file.type === "image/jpeg" ||
          file.type === "image/jfif"
      );
  
      api.setFile(
        validFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
  
      api.setImages([]);
      api.setFile(validFiles);
      setDrag(false);
      navigate("/upload");
    },
  });
  

  const closeModal = () => {
    setIsModalVisible(false);
    setUnmatchedFolders([]);
  };

  const handleFolderSelect = (event) => {
    api.setFile([]);
    api.setUploadProgress({});
    api.setUploading(false);
    api.setUploadedCount(0);
    api.setUploadSpeed(0);
    api.setTimeRemaining(0);
    
    const fileList = event.target.files;
    const fileArray = [];

    for (let file of fileList) {
      fileArray.push({ file, relativePath: file.webkitRelativePath });
    }

    api.setFile(fileArray);
    api.setUploadProgress({});
    api.setUploadedCount(0);
    api.setUploadSpeed(0);
    api.setTimeRemaining(0);
  };

  if (api.file.length > 0) {
    return (
      <Upload_Routes
        file={api.file}
        setFile={api.setFile}
        selectedOption={selectedOption}
      />
    );
  }
  return (
    <div className="Login">
      <div
        className="Images_Filter_Container"
        style={{ width: "70%", marginTop: "4vh" }}
      >
        <div className="Filter_Upload_Type">
          <React.Fragment>
            <span style={{ fontWeight: "bold", color: "#38514C" }}>
              Geolocation Year - {defaultYear}
            </span>
          </React.Fragment>

          <div className="Radio_Buttons_Container">
            {radioOptions.map((option) => (
              <label className="Radio_Buttons_Single" key={option.id}>
                <input
                  type="radio"
                  value={option.id}
                  checked={selectedOption === option.id}
                  onChange={() => handleOptionChange(option.id)}
                />
                {option.displayName}
              </label>
            ))}
          </div>
        </div>
      </div>

      {selectedOption === 3 ? (
        <div className="upload" style={{ marginTop: "50px" }}>
          <div className="upload_container">
            <div className="upload_heading">
              <span>Upload Your Images</span>
            </div>
            <div className="upload_symbol">
              <img
                src={require("../Assets/Upload_Images/Upload_Symbol.png")}
                alt=""
              />
            </div>
            <div className="upload_description">
              <span>Drag and drop your images here or choose folder</span>
            </div>
            <div className="upload_button">
              <div className="Login_Button upload_button">
                <button
                  onClick={() => document.getElementById("folderInput").click()}
                >
                  Browse Files
                </button>
                <input
                  type="file"
                  id="folderInput"
                  style={{ display: "none" }}
                  webkitdirectory="true"
                  directory="true"
                  multiple
                  onChange={handleFolderSelect}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          className="upload"
          {...getRootProps()}
          style={{ marginTop: "50px" }}
        >
          <input {...getInputProps({ accept: "image/png" })} />
          {!drag ? (
            <div className="upload_container">
              <div className="upload_heading">
                <span>Upload Your Images</span>
              </div>
              <div className="upload_symbol">
                <img
                  src={require("../Assets/Upload_Images/Upload_Symbol.png")}
                  alt=""
                />
              </div>
              <div className="upload_description">
                <span>Drag and drop your images here or choose folder</span>
              </div>
              <div className="upload_button">
                <div className="Login_Button upload_button">
                  <button>Browse Files</button>
                </div>
              </div>
            </div>
          ) : (
            <div className="drop_container">
              <span>Drop your images here</span>
            </div>
          )}
        </div>
      )}

      <Modal
        title={
          <span
            style={{
              fontSize: "1.2rem",
              fontWeight: "bold",
              color: "#38514C",
            }}
          >
            ⚠️ Unmatched Folder Names
          </span>
        }
        open={isModalVisible}
        onCancel={closeModal}
        footer={[
          <Button
            key="close"
            onClick={closeModal}
            style={{
              border: "none",
              fontSize: "0.8rem",
            }}
          >
            Close
          </Button>,
        ]}
        style={{
          // top: "20%",
          borderRadius: "2vw",
        }}
      >
        <p
          style={{
            fontSize: "0.8rem",
            color: "#444",
            fontWeight: "500",
            marginBottom: "1vh",
          }}
        >
          The following folders do not match any camera IDs:
        </p>
        <ul
          style={{
            backgroundColor: "#f8f8f8",
            padding: "12px",
            borderRadius: "8px",
            maxHeight: "40vh",
            overflowY: "auto",
            listStyleType: "none",
            border: "1px solid #ddd",
          }}
        >
          {unmatchedFolders.map((folder, index) => (
            <li
              key={index}
              style={{
                padding: "6px 10px",
                marginBottom: "5px",
                borderBottom: "1px solid #ddd",
                fontSize: "14px",
                color: "#555",
              }}
            >
              📁 {folder}
            </li>
          ))}
        </ul>
      </Modal>
    </div>
  );
};

export default Upload;
